import React from 'react';
import { Button, ButtonSize } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

interface Props {
  link?: string;
  size?: ButtonSize;
}

const TradeNowButton: React.FC<Props> = ({
  link = 'https://www.benzinga.com/go/start-investing/?pl=trade-now',
  size,
}) => {
  return (
    <Container className="trade-now-button" href={link} rel="noreferrer" target="_blank">
      <Button size={size} variant="primary">
        Trade Now
      </Button>
    </Container>
  );
};

export default TradeNowButton;

const Container = styled.a`
  &.trade-now-button {
    display: block;
    > button {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
`;
